import { createContext } from 'react'

/**
 * Context for providing MeetingDetail dependencies.
 * This allows each feature to provide its own implementations
 * without the shared component needing to import from features.
 */
export const MeetingDetailDependenciesContext = createContext(null)
